import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvListStateMessageProps {
  icon: ReactNode;
  title: string;
  description?: string;
  isAlert?: boolean;
  children?: ReactNode;
}

const OvListStateMessage: FC<OvListStateMessageProps> = ({
  icon,
  title,
  description = '',
  isAlert = false,
  children = null,
}) => (
  <Wrapper role={isAlert ? 'alert' : undefined}>
    <IconCircle aria-hidden="true">{icon}</IconCircle>
    <Title>{title}</Title>
    {description && <Description>{description}</Description>}
    {children}
  </Wrapper>
);

export default OvListStateMessage;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4rem 1.25rem;
  text-align: center;
`;

const IconCircle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: ${Variables.borderRadius.CIRCLE};
  background-color: ${Colours.LIGHT_GRAY_BLUE};

  .MuiSvgIcon-root {
    width: 1.75rem;
    height: 1.75rem;
  }
`;

const Title = styled.h2`
  margin: 0.875rem 0 0.375rem;
  font-size: ${Variables.fontSizes.MLARGE};
`;

const Description = styled.p`
  margin: 0 0 1rem;
  color: ${Colours.OV_CHARCOAL};
  font-size: ${Variables.fontSizes.MEDIUM};
`;
